(function () {
  function init() {
    document.querySelectorAll('form.product-form').forEach(function (form) {
      const wrapper = form.querySelector('.atc-wrapper');
      if (!wrapper) return;

      const btn = wrapper.querySelector('.custom-add-to-cart-button');
      const dropdown = wrapper.querySelector('[data-atc-variants]');
      const list = dropdown && dropdown.querySelector('.atc-variants-list');

      if (!(btn && dropdown && list)) return;

      const openDropdown = function () {
        dropdown.removeAttribute('hidden');
        btn.setAttribute('aria-expanded', 'true');
      };

      const closeDropdown = function () {
        dropdown.setAttribute('hidden', '');
        btn.setAttribute('aria-expanded', 'false');
      };

      btn.addEventListener('click', function (evt) {
        evt.preventDefault();
        evt.stopPropagation();
        evt.stopImmediatePropagation();
        
        const isHidden = dropdown.hasAttribute('hidden');
        if (isHidden) {
          openDropdown();
        } else {
          closeDropdown();
        }
      }, true);

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' || e.key === 'Esc') {
          if (!dropdown.hasAttribute('hidden')) {
            closeDropdown();
          }
        }
      });

      document.addEventListener('click', function (e) {
        if (!wrapper.contains(e.target) && !dropdown.hasAttribute('hidden')) {
          closeDropdown();
        }
      });

      list.addEventListener('click', function (e) {
        const opt = e.target.closest('.atc-variant-option');
        if (!opt || opt.classList.contains('is-disabled')) return;
        const variantId = opt.getAttribute('data-variant-id');
        if (!variantId) return;

        closeDropdown();

        const select = form.querySelector('select[name="id"]');
        if (select) {
          select.value = variantId;
          select.dispatchEvent(new Event('change', { bubbles: true }));
        } else {
          const radioMatch = form.querySelector('input[type="radio"][name="id"][value="' + variantId + '"]');
          if (radioMatch) {
            radioMatch.checked = true;
            radioMatch.dispatchEvent(new Event('change', { bubbles: true }));
          } else {
            let idInput = form.querySelector('input[name="id"]');
            if (!idInput) {
              idInput = document.createElement('input');
              idInput.type = 'hidden';
              idInput.name = 'id';
              form.appendChild(idInput);
            }
            idInput.value = variantId;
          }
        }

        try {
          const themeButton = form.querySelector('[data-add-to-cart]');
          document.dispatchEvent(new CustomEvent('theme:cart:add', { detail: { button: themeButton }, bubbles: false }));
        } catch (e) {
          console.error('Dispatch theme:cart:add failed, falling back to form submit', e);
          if (typeof form.requestSubmit === 'function') {
            form.requestSubmit();
          } else {
            const s = document.createElement('button');
            s.type = 'submit';
            s.style.display = 'none';
            form.appendChild(s);
            s.click();
            s.remove();
          }
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();